export default "assets/images/flags/gb-ec338c69.svg";